"use client";

import { FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { SoftAgeVerification as SoftAgeVerificationUI } from "@jti/ui/eva-components/SoftAgeVerification";

import { useLanguages } from "@/hooks/useLanguages";
import { useDisplayModelComponent } from "@/libs/builder/hooks/useDisplayModelComponent";

import { softAgeVerificationInputs } from "./SoftAgeVerification.builder";

type SoftAgeVerificationProps = BuilderComponentProps<
  typeof softAgeVerificationInputs
>;

export const SoftAgeVerification: FC<
  PropsWithChildren<SoftAgeVerificationProps>
> = ({
  children,
  backgroundColor,
  logo,
  isLogoEnabled = true,
  shouldPageReload = false,
}) => {
  const languages = useLanguages();

  const shouldDisplayModelComponent = useDisplayModelComponent(
    "soft-age-verification"
  );

  if (shouldDisplayModelComponent) {
    return (
      <SoftAgeVerificationUI
        languages={languages}
        isAuthorMode={isEditing()}
        logo={{ ...logo, isDarkMode: false }}
        backgroundColor={backgroundColor}
        isLogoEnabled={isLogoEnabled}
        shouldPageReload={shouldPageReload}
      >
        {children}
      </SoftAgeVerificationUI>
    );
  }

  return null;
};
